import Link from 'next/link'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import clsx from 'clsx'
import Typo from 'constants/typography'
import ICONS from 'components/common/icon/const'
import Icon from 'components/common/icon'
import Badge from 'components/common/badge'
import { BADGE_COLOR } from 'components/common/badge/const'
import Wrapper from 'components/wrapper'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './style.scss'

function getIcon(id) {
  switch (id) {
    case 60:
      return ICONS.basicInfo
    case 62:
      return ICONS.purchasing
    case 63:
      return ICONS.payment
    case 64:
      return ICONS.discount
    case 65:
      return ICONS.shipping
    case 66:
      return ICONS.order
    case 67:
      return ICONS.return
    case 68:
      return ICONS.sizing
    case 69:
      return ICONS.contact
    case 110:
      return ICONS.privacy
    case 112:
      return ICONS.tc
    case 0:
      return ICONS.store
    case 301:
      return ICONS.faqLoyalty
    case 305:
      return ICONS.italist
    case 'cookies-setting':
      return ICONS.setting
    default:
      return ICONS.basicInfo
  }
}

const ImageLinks = (props) => {
  const { list, shop, lang, t, isPhone } = props
  const iconSize = isPhone ? 72 : 80
  const prefixLink = `/${shop}/${lang}`

  return (
    <div className="page-container">
      <style jsx>{styles}</style>
      {list?.map((listItem) => {
        const { id_faq, title, link_rewrite } = listItem
        let hrefLink = `/faq?type=${link_rewrite}`
        let asLink = `${prefixLink}/info/${link_rewrite}`

        if (link_rewrite === 'stores') {
          hrefLink = '/offline'
          asLink = `${prefixLink}/offline`
        }

        const icon = getIcon(id_faq)

        return (
          <div key={id_faq} className="image-links">
            <Link href={hrefLink} as={asLink}>
              <a>
                <Wrapper
                  condition={id_faq === 67}
                  wrapper={(children) => (
                    <Badge
                      color={BADGE_COLOR.secondary}
                      content={hasLocizeTranslation(t, 'BADGE_NEW', 'NEW')}
                      className="image-links__badge"
                    >
                      {children}
                    </Badge>
                  )}
                >
                  <Icon
                    size={iconSize}
                    className="img-responsive faq-image"
                    src={icon}
                  />
                </Wrapper>
                <span className={clsx('title', Typo.body2)}>{t(title)}</span>
              </a>
            </Link>
          </div>
        )
      })}
    </div>
  )
}

ImageLinks.propTypes = {
  lang: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({})),
  shop: PropTypes.string,
  isPhone: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

ImageLinks.defaultProps = {
  lang: undefined,
  list: undefined,
  shop: undefined,
  isPhone: undefined,
}

const Extended = translate('global')(ImageLinks)

export { ImageLinks }

export default connect(
  /* istanbul ignore next */
  (state) => ({
    isPhone: state.device.isPhone,
  }),
)(Extended)
